<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-card no-body class="bg-light">
          <b-card-header class="pb-0 border-0">
            <h3 class="card-title"><b>Detalles del conductor</b></h3>
          </b-card-header>
          <b-card-body>
            <div class="form-group clearfix" v-if="firebaseDriver.driver">
              <label class="sr-only">Fotografía del conductor</label>
              <base-image-input v-model="imageData" :imagen="getDriverById.profilePicture" />
              <div class="ml-4 mt-4 float-left text-left">
                <p class="mb-0"><b>{{ firebaseDriver.driver.firstName }} {{ firebaseDriver.driver.lastName }}</b></p>
                <p class="mb-0">{{ firebaseDriver.driver.phoneNumber }}</p>
                <p class="mb-0">{{ firebaseDriver.rate.rating }}<i class="fa fa-star" style="font-size: 0.7em;"></i></p>
              </div>
            </div>
            <div class="form-group">
              <label>Nombre(s):</label>
              <p><strong>{{ getDriverById.firstName }}</strong></p>
            </div>
            <div class="form-group">
              <label>Apellidos:</label>
              <p><strong>{{ getDriverById.lastName }}</strong></p>
            </div>
            <div class="form-group">
              <label>Fecha de nacimiento:</label>
              <p><strong>{{ getDriverById.dateOfBirth }}</strong></p>
            </div>
            <div class="form-group">
              <label>Número de teléfono:</label>
              <p><strong>{{ getDriverById.phoneNumber }}</strong></p>
            </div>
            <div class="form-group">
              <label>Correo electrónico:</label>
              <p><strong>{{ getDriverById.email }}</strong></p>
            </div>
            <div class="form-group">
              <label>RFC:</label>
              <p><strong>{{ getDriverById.rfc }}</strong></p>
            </div>
            <div class="form-group">
              <label>Número de tarjetón:</label>
              <p><strong>{{ getDriverById.cardId }}</strong></p>
            </div>
            <div class="form-group">
              <label>Fecha de vencimiento del tarjetón:</label>
              <p><strong v-if="getDriverById">{{ getDriverById.cardExpiration }}</strong></p>
            </div>
            <div class="form-group">
              <label>Número de licencia:</label>
              <p><strong>{{ getDriverById.license }}</strong></p>
            </div>
            <div class="form-group">
              <label>Fecha de vencimiento de la licencia:</label>
              <p><strong>{{ getDriverById.licenseExpiration }}</strong></p>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="8">
        <b-card no-body class="bg-light">
          <b-card-header class="pb-0 border-0">
            <h3 class="card-title"><b>Ubicación del conductor</b></h3>
          </b-card-header>
          <b-card-body class="pl-3 pr-3 pt-2 pb-0 bg-white">
            <DriverMap :firebaseDriver="firebaseDriver" />
          </b-card-body>
          <b-card-footer></b-card-footer>
        </b-card>
        <b-card no-body class="bg-light">
          <b-card-header class="pb-0 border-0">
            <div class="row">
              <div class="col-md-6">
                <h3 class="card-title"><b>Historial de viajes</b></h3>
              </div>
              <div class="col-md-6 text-end text-right">
                <button type="button" class="btn btn-link" @click="csvExport(csvData)">Descargar historial</button>
              </div>
            </div>
          </b-card-header>
          <b-card-body v-if="!loadingTrips" class="pl-3 pr-3 pt-2 pb-0 bg-white">
            {{ trips.length }}
            <b-table
              show-empty
              :items="trips"
              :fields="fieldsTrips"
              small
              borderless
            >
              <template v-slot:cell(cancelled)="row">
                <span v-if="row.item.cancelled" class="badge badge-danger">Cancelado</span>
                <span v-else class="badge badge-success">Completado</span>
              </template>
              <template v-slot:cell(totalTripAmount)="row">
                $ {{ row.item.totalTripAmount }}
              </template>
              <template v-slot:cell(banderazo)="row">
                $ {{ row.item.banderazo }}
              </template>
              <template v-slot:cell(distance)="row">
                {{ truncateDecimals(row.item.distance) }} km
              </template>
              <template v-slot:cell(duration)="row">
                <span v-if="row.item.duration">{{ row.item.duration }}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(tripSource)="row">
                <b-badge v-if="row.item.tripSource == 'SND'" variant="default">{{ row.item.tripSource }}</b-badge>
                <b-badge v-if="row.item.tripSource == 'PLN'" variant="secondary">{{ row.item.tripSource }}</b-badge>
                <b-badge v-if="row.item.tripSource == 'APP'" variant="success">{{ row.item.tripSource }}</b-badge>
              </template>
            </b-table>
          </b-card-body>
          <b-card-body v-else class="pl-3 pr-3 pt-2 pb-0 bg-white">
            <div class="text-center py-3">
              <b-spinner variant="warning" label="Spinning">Cargando</b-spinner>
            </div>
          </b-card-body>
          <b-card-footer></b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import moment from 'moment'
import BaseImageInput from '@/components/imageInput'
import firebase from 'firebase'
import headers from '@/config/headers.js'
// import { required, helpers, alphaNum, numeric } from 'vuelidate/lib/validators'
import DriverMap from '@/components/maps/travelMap/DriverMap'
import json2csv from 'json2csv'
// import VueCsvDownloader from 'vue-csv-downloader'
moment.locale('es-mx')
//
const DRIVER_TRIPS = gql`
query getTripsByDriverId($driverId: Int) {
  getTripsByDriverId(driverId: $driverId) {
    id
    driverId
    concesionId
    concesionNumber
    fareType
    estimatedFare
    date
    duration
    distance
    paymentMethod
    totalTripAmount
    pickUpLat
    pickUpLng
    destinationLat
    destinationLng
    status
    cancelled
    startedAt
    finishedAt
    turno
    distanciaAplicada1
    distanciaAplicada2
    cobroTiempo
    banderazo
    typeOfCharge
    tripOrigin
    tripDestination
    tripSource
    appCharge
    fareByVehicleType
    fixedFareId
    preferential
    extraStartedPrice
    siteId
  }
}
`
export default {
  data() {
    return {
      error: null,
      disabledButton: false,
      imageData: null,
      imageLoadData: null,
      selectedActive: '1',
      optionsActive: [
        { text: 'Sí', value: '1' },
        { text: 'No', value: '0' },
      ],
      fieldsTrips: [
        // { key: 'concesionNumber', label: '# Concesión' },
        { key: 'tripSource', label: 'Viaje' },
        { key: 'startedAt', label: 'Fecha' },
        { key: 'fareType', label: 'Tarifa' },
        { key: 'turno', label: 'Turno' },
        { key: 'duration', label: 'Duración' },
        { key: 'distance', label: 'Distancia' },
        { key: 'banderazo', label: 'Banderazo' },
        { key: 'totalTripAmount', label: 'Total' },
        { key: 'cancelled', label: 'Completado' },
      ],
      fieldsCsvTrips: [
        { key: 'appCharge' },
        { key: 'banderazo' },
        { key: 'cancelled' },
        { key: 'cobroTiempo' },
        { key: 'concesionId' },
        { key: 'concesionNumber' },
        { key: 'date' },
        { key: 'destinationLat' },
        { key: 'destinationLng' },
        { key: 'distance' },
        { key: 'distanciaAplicada1' },
        { key: 'distanciaAplicada2' },
        { key: 'driverId' },
        { key: 'duration' },
        { key: 'estimatedFare' },
        { key: 'extraStartedPrice' },
        { key: 'fareByVehicleType' },
        { key: 'fareType' },
        { key: 'finishedAt' },
        { key: 'fixedFareId' },
        { key: 'id' },
        { key: 'paymentMethod' },
        { key: 'pickUpLat' },
        { key: 'pickUpLng' },
        { key: 'preferential' },
        { key: 'siteId' },
        { key: 'startedAt' },
        { key: 'status' },
        { key: 'totalTripAmount' },
        { key: 'tripDestination' },
        { key: 'tripOrigin' },
        { key: 'tripSource' },
        { key: 'turno' },
        { key: 'typeOfCharge' },
      ],
      trips: [],
      objectFile: [],
      id: this.$route.params.id,
      form: this.$form.createForm(this),
      getDriverById: {
        active: this.$route.params.active,
        cardExpiration: this.$route.params.cardExpiration,
        cardId: this.$route.params.cardId,
        firstName: this.$route.params.firstName,
        lastName: this.$route.params.lastName,
        license: this.$route.params.license,
        licenseExpiration: this.$route.params.licenseExpiration,
        phoneNumber: this.$route.params.phoneNumber?.replace('+52', ''),
        profilePicture: this.$route.params.profilePicture,
        email: this.$route.params.email,
        address: {
          city: this.$route.params.driverAddress ? this.$route.params.driverAddress.city : '',
          extNumber: this.$route.params.driverAddress ? this.$route.params.driverAddress.extNumber : '',
          intNumber: this.$route.params.driverAddress ? this.$route.params.driverAddress.intNumber : '',
          postalCode: this.$route.params.driverAddress ? this.$route.params.driverAddress.postalCode : '',
          state: this.$route.params.driverAddress ? this.$route.params.driverAddress.state : '',
          suburb: this.$route.params.driverAddress ? this.$route.params.driverAddress.suburb : '',
          street: this.$route.params.driverAddress ? this.$route.params.driverAddress.street : '',
        },
        rfc: this.$route.params.rfc ? this.$route.params.rfc : '',
        dateOfBirth: this.$route.params.dateOfBirth ? this.$route.params.dateOfBirth : '',
      },
      firebaseDriver: {},
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      driver: null,
      estados: ['Ciudad de México', 'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
        'Coahuila de Zaragoza', 'Colima', 'Chiapas', 'Chihuahua', 'Durango', 'Guanajuato', 'Guerrero',
        'Hidalgo', 'Jalisco', 'México', 'Michoacán de Ocampo', 'Morelos', 'Nayarit', 'Nuevo León',
        'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
        'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz de Ignacio de la Llave', 'Yucatán', 'Zacatecas'],
      municipios: [],
      codigos: [],
      colonias: [],
      data: {},
      loadingTrips: true,
      failCopy: 'No se encontró al conductor en el mapa. Intenta más tarde, si el problema persiste ponte en contacto con el administrador.',
    }
  },
  apollo: {
    getDriverById: {
      query: gql`
        query getDriverById($id: Int!) {
          getDriverById(id: $id) {
            id
            active
            cardExpiration
            cardId
            firstName
            lastName
            license
            licenseExpiration
            phoneNumber
            profilePicture
            email
          }
        }
      `,
      context: headers(),
      error (erro) {
        console.log('ERR=R ', erro)
      },
      variables() {
        return {
          id: this.id ? parseInt(this.$route.params.id) : 1,
        }
      },
      result({ data }) {
        console.log('getDriverById ===================>', data.getDriverById)
        this.getDriverById = data.getDriverById
        // this.getDriverById.phoneNumber = data.getDriverById.phoneNumber.replace('+52', '')
        // this.phoneNumberEdition = this.getDriverById.phoneNumber
        // this.emailEdition = data.getDriverById.email
      },
    },
  },
  methods: {
    async getFirebaseDriver(driverId) {
      try {
        console.log('getFirebaseDriver', driverId)
        const driver = await firebase.firestore().collection('drivers').where('driver.id', '==', parseInt(driverId)).get()
        console.log('Driver', driver.docs.length)
        if (driver.docs.length === 0) {
          this.makeToast(true, 'danger', 'Error', this.failCopy)
          return
        }
        this.firebaseDriver = driver.docs[0].data()
      } catch (error) {
        this.makeToast(true, 'danger', 'Error', this.failCopy)
      }
    },
    async getDriverTrips(driverId) {
      try {
        console.log('getDriverTrips', moment().format('YYYY-MM-DD'))
        const trips = await this.$apollo.query({ query: DRIVER_TRIPS, context: headers(), variables: { driverId: parseInt(this.$route.params.id) } })
        console.log('trips', trips)
        if (trips.data.getTripsByDriverId) {
          trips.data.getTripsByDriverId.map((trip) => {
            if (trip) {
              this.trips.push(trip)
            }
          })
          // this.trips = [...this.trips, ...trips.data.getTripsByDriverId]
          console.log('this.trips', this.trips)
          this.loadingTrips = false
        } else {
          this.makeToast(true, 'danger', 'Error', this.failCopy)
          this.loadingTrips = false
          return
        }
      } catch (err) {
        this.makeToast(true, 'danger', 'Error', this.failCopy)
        this.loadingTrips = false
      }
    },
    changeStartDate(event) {
      this.getDriverById.dateOfBirth = event ? this.defineDate(event._d) : this.todayDate()
    },
    truncateDecimals(amount) {
      if (!amount) { return '0.00' }
      return parseFloat(amount).toFixed(2)
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
    csvExport(arrData) {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += [
        Object.keys(arrData[0]).join(';'),
        ...arrData.map(item => Object.values(item).join(';')),
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')

      const data = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', 'historial.csv')
      link.click()
    },
  },
  created() {
    this.getFirebaseDriver(this.$route.params.id)
    this.getDriverTrips(this.$route.params.id)
    console.log('this.getDriverById', this.getDriverById)
    //
    // if (this.$route.params.driverAddress) {
    // this.data = require(`../../../services/data/${this.getDriverById.address.state}.json`)
    // this.municipios = this.data[this.getDriverById.address.state]
    // this.codigos = this.municipios[this.getDriverById.address.city]
    // this.colonias = this.codigos[this.getDriverById.address.postalCode]
    // }
  },
  computed: {
    downloadUrl() {
      console.log('downloadUrl', this.data)
      return this.data.length > 0 ? 'data:text/csv,' + encodeURIComponent(json2csv({ data: this.data, fields: this.fields })) : 'javascript:void(0);'
    },
    csvData() {
      return this.trips.map(item => ({
        ...item,
      }))
    },
  },
  components: {
    BaseImageInput,
    DriverMap,
  },
}
</script>
